// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"225":"rooms","239":"settings-stat"}[chunkId] + "." + {"225":"3629d4fd","239":"adf2d640"}[chunkId] + ".css";
};